import * as React from 'react';

import AssessmentResult from '../../containers/AssessmentResult';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * アセスメント結果表示画面
 * @param props
 */
const TestResult: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('AssessmentResult_0014')} />
			<AssessmentResult
				careerId={props.match.params.career_id}
				classId={props.match.params.class_id}
				rankId={props.match.params.rank_id}
				adminView={false}
			/>
		</>
	);
};

export default TestResult;



// WEBPACK FOOTER //
// ./src/pages/personal/AssessmentResult.tsx